import React from "react";
import { useGetAccountBaseMapsQuery } from "../../../../generated/graphql";
import { spacing } from "../../../../stitches.config";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Buttons/Button";
import Divider from "../../../Common/Divider";
import { EmptyState } from "../../../Common/EmptyState";
import { Header, HeaderTitle, Section } from "../../__styles__/Content";
import { useAddBaseMapModal } from "./AddBaseMapModal";
import Table from "./Table";

export const BaseMaps = () => {
  const { account } = React.useContext(AuthContext);
  const [showAddBaseMapModal] = useAddBaseMapModal();
  const { data, loading } = useGetAccountBaseMapsQuery({
    variables: {
      accountId: account!.id,
    },
  });

  const baseMapData = data?.account?.baseMaps || [];
  const hasBaseMaps = !loading && baseMapData.length > 0;

  return (
    <Box>
      <Header>
        <HeaderTitle>Base map settings</HeaderTitle>
        <Button
          variant="outline"
          onPress={showAddBaseMapModal}
          size="small"
          iconStart="plus"
          title="Add Base map"
        />
      </Header>
      <Divider></Divider>
      {!loading &&
        (hasBaseMaps ?
          <Section>
            <Table baseMapData={baseMapData} />
          </Section>
        : <EmptyState
            icon="add-raster"
            title="No base maps for this account"
            body="Add a base map to get started."
            paddingTop={spacing["2xl"].value}
            paddingBottom={spacing["2xl"].value}
          />)}
    </Box>
  );
};

export default BaseMaps;
